import StringTemplateVariablesMgr, {
	TTemplateVariables,
} from 'coreClasses/stringTemplateVariables/StringTemplateVariablesMgr';

/**
 * Manages the template variables resolving.
 */
class StringTemplateResolver {
	/**
	 * @constructor
	 * @param {StringTemplateVariablesMgr} stringTemplateVariablesMgr - The string template variables manager.
	 */
	constructor(private stringTemplateVariablesMgr: StringTemplateVariablesMgr) {
		this.stringTemplateVariablesMgr = stringTemplateVariablesMgr;
	}

	/**
	 * Resolves the provided template string using the available variables.
	 *
	 * @param {string} str - The template string to be resolved.
	 * @returns {string} The resolved string.
	 */
	public resolve(str: string, variables?: TTemplateVariables): string {
		// If the string doesn't contain any template placeholders, return it as-is.
		if (!str.includes('{{')) {
			return str;
		}

		// Try to get the template variables from the provided variables object.
		// Or, if no variables were provided, get them from StringTemplateVariablesMgr.
		const templateVariables = variables || this.stringTemplateVariablesMgr.getVariables();

		return Object.keys(templateVariables || {}).reduce((acc, key) => {
			const variablePattern = new RegExp(`{{${key}}}`, 'g');

			return acc.replace(variablePattern, templateVariables[key] as string);
		}, str);
	}
}

export default StringTemplateResolver;
